// extracted by mini-css-extract-plugin
export default {"check":"styles_check__61KrT","right":"styles_right__jUx9N","left":"styles_left__q2zaz","mark":"styles_mark__Sjcea","dark":"styles_dark__69VXO"};